import React from 'react';
import { type Router } from '@helpers/types';
import { Outlet, createRootRoute } from '@tanstack/react-router';

import App from '../pages/_app';

const SyntheticRouter = {} as Router;

const TSRApp = () => <App Component={Outlet} pageProps={{}} router={SyntheticRouter} />;

export const Route = createRootRoute({
  component: TSRApp
});
